import React, { forwardRef, useImperativeHandle,useRef,useEffect } from "react";
// import React, { forwardRef, useImperativeHandle, useRef, useEffect, useState } from "react";
import ComponentTagSelector from "../tags/ComponentTagSelector";

import { useMasterData } from "../../context/MasterDataContext";



const Comp_ClientContactTypes = forwardRef(({
    maxTags = undefined,
    // style = '',

    style={},   // container style
    tagStyle={},  // tags
    inputStyle={}, // input field
    displayKey="type",

    defaultTags = [],
    selectedTags = [],
    setSelectedTags = () => {},

    onClientContactTypeSelect,
    onClientContactTypeRemove,
    onClientContactTypeChangeTag,
}, ref) => {
    const placeHolder = "Select Contact Type";

    const {clientContactTypes:masterClientContactTypes,clientContactTypesReady:ClientContactTypeReady}= useMasterData();
    

    const tagrefClientContactType = useRef(null);
    const hasInitialized = useRef(false);


    // console.log("master Client Contact Types",masterClientContactTypes);
/**
     * Resolve Client Type IDs or mixed tags into full colony objects from masterClienttype.
     * @param {Array<number|string|object>} idsOrObjects
     * @param {string} defaultStatus
     * @returns {Array<object>}
     */
    function getObjectFromIds(idsOrObjects ,defaultStatus = "default") {
      if (!Array.isArray(idsOrObjects) || !Array.isArray(masterClientContactTypes)) return [];
      return idsOrObjects
        .map(tagOrId => {
          if (tagOrId && typeof tagOrId === 'object' && 'id' in tagOrId && 'type' in tagOrId) {
            return tagOrId;
          }
          const rawId = typeof tagOrId === 'string' && /^\d+$/.test(tagOrId)
            ? parseInt(tagOrId, 10)
            : tagOrId;
          return masterClientContactTypes.find(col => {
            const cid = col.id;
            return (
              (typeof cid === 'number' && cid === rawId) ||
              (typeof cid === 'string' && cid === ('' + rawId))
            );
          });
        })
        .filter(Boolean)
        .map(ctype => ({
          ...ctype,
          status: defaultStatus
        }));
      }



        // useEffect(() => {
        //     if (
        //         !hasInitialized.current && 
        //         Array.isArray(defaultTags) &&
        //         defaultTags.length > 0 &&
        //         tagrefClientContactType.current &&
        //         ClientContactTypeReady &&
        //         Array.isArray(masterClientContactTypes) &&
        //         masterClientContactTypes.length > 0
        //         ) {
        //         tagrefClientContactType.current.setTags(defaultTags);
        //         hasInitialized.current = true;
        //         // console.log("✅ setTags called with:", defaultTags);
        //     }
        // //     {
        // //     const initialTags = getObjectFromIds(defaultTags);
        // //     tagrefClientContactType.current.setTags(initialTags);
        // //     hasInitialized.current = true;
        // // }

        //  {
        //     const initialTags = getObjectFromIds(defaultTags); // convert IDs → full objects
        //     tagrefClientContactType.current.setTags(initialTags);
        //     hasInitialized.current = true;
        //     // console.log("✅ ClientContactTypes initialized with:", initialTags);
        // }

        // }, [defaultTags?.length,masterClientContactTypes,ClientContactTypeReady]);

// useEffect(() => {
//   if (
//     !hasInitialized.current &&
//     Array.isArray(defaultTags) &&
//     defaultTags.length > 0 &&
//     tagrefClientContactType.current &&
//     ClientContactTypeReady &&
//     Array.isArray(masterClientContactTypes) &&
//     masterClientContactTypes.length > 0
//   ) {
//     const initialTags = getObjectFromIds(defaultTags); // convert IDs → full objects

//     tagrefClientContactType.current.setTags(initialTags);
//     hasInitialized.current = true;
//     // console.log("✅ ClientContactTypes initialized with:", initialTags);
//   }
//   // console.log("masterClientContactTypes",masterClientContactTypes);
//   // console.log("defaultTags",defaultTags);

// }, [defaultTags?.length, masterClientContactTypes, ClientContactTypeReady]);





useEffect(() => {
  if (
    !hasInitialized.current &&
    Array.isArray(defaultTags) &&
    defaultTags.length > 0 &&
    tagrefClientContactType.current &&
    ClientContactTypeReady &&
    Array.isArray(masterClientContactTypes) &&
    masterClientContactTypes.length > 0
  ) {
    const initialTags = getObjectFromIds(defaultTags); // convert IDs → full objects

    tagrefClientContactType.current.setTags(initialTags);
    hasInitialized.current = true;
    // console.log("✅ ClientContactTypes initialized with:", initialTags);
  }
  // console.log("masterClientContactTypes",masterClientContactTypes);
  // console.log("defaultTags",defaultTags);

}, [ ClientContactTypeReady]);



useEffect(() => {
  if (
    Array.isArray(selectedTags) &&
    selectedTags.length > 0 &&
    ClientContactTypeReady &&
    Array.isArray(masterClientContactTypes) &&
    masterClientContactTypes.length > 0
  ) {
    const allObjects = selectedTags.every(
      t => t && typeof t === 'object' && 'id' in t && 'type' in t
    );
    if (allObjects) return;

    const resolvedTags = selectedTags
      .map(tagOrId => {
        if (tagOrId && typeof tagOrId === 'object' && 'id' in tagOrId && 'type' in tagOrId)
          return tagOrId;

        const idNum = typeof tagOrId === 'string' && /^\d+$/.test(tagOrId) ? parseInt(tagOrId, 10) : tagOrId;
        return masterClientContactTypes.find(t => t.id === idNum);
      })
      .filter(Boolean);

    setSelectedTags(resolvedTags);
  }
}, [selectedTags, ClientContactTypeReady, masterClientContactTypes]);






        // useEffect(() => {
        //     if (!hasInitialized.current && defaultTags && defaultTags.length > 0 && tagrefClientContactType.current) {
        //         tagrefClientContactType.current.setTags(defaultTags);
        //         hasInitialized.current = true;
        //         // console.log("✅ setTags called with:", defaultTags);
        //     }
        // }, [defaultTags?.length]);




    // const [tags, setTags] = useState(defaultTags || []);

    // // Update tags when defaultTags changes
    // useEffect(() => {
    //     setTags(defaultTags || []);
    // }, [defaultTags]);

    // Debugging: Log defaultTags and masterUserTypes
    // useEffect(() => {
    //     // console.log("defaultTags in Comp_ClientTypes:", defaultTags);
    //     // console.log("masterClientContactTypes in Comp_ClientTypes:", masterContactClientTypes);
    // }, [defaultTags, masterClientContactTypes]);

    const handleSelectTag = (tag) => {
        if (onClientContactTypeSelect) {
            onClientContactTypeSelect(tag);
        }
    };

    const handleRemoveTag = (tag) => {
        if (onClientContactTypeRemove) {
            onClientContactTypeRemove(tag);
        }
    };

    const handleChangeTag = (AllTags) => {
        if (onClientContactTypeChangeTag) {
            onClientContactTypeChangeTag(AllTags);
        }
    };




    // Expose methods using ref
    useImperativeHandle(ref, () => ({
        // getClientTypeTags: () => tagrefClientContactType.current.getTags(),
        // setClientTypeTags: (selected) => tagrefClientContactType.current.setTags(selected),
        getObjectFromIds,
        getClientContactTypeTags: () => selectedTags,
        setClientContactTypeTags: (tags) => setSelectedTags(tags),            
        getTagsbyIds: (ids) => getTags(ids)
    }));





    function getTags(ids) {
        if (ids.length > 0) {
            return masterClientContactTypes.filter(record => ids.includes(record.id));
        } else {
            return [];
        }
    }

    return (
        <div>
            <ComponentTagSelector
                ref={tagrefClientContactType}
                // style={style}

                style={style}        // container style
                tagStyle={tagStyle}  // tags
                inputStyle={inputStyle} // input field

                suggestions={masterClientContactTypes} // Ensure this is populated

                // defaultTags={defaultTags} // Use internal state for defaultTags

                selectedTags={selectedTags}
                setSelectedTags={setSelectedTags}
                maxTags={maxTags}
                displayKey={displayKey} // Ensure this matches the key in masterUserTypes
                allowFreeAdd={false}
                placeHolder={placeHolder}
                onSelectTag={handleSelectTag}
                onRemoveTag={handleRemoveTag}
                onChangeTag={handleChangeTag}
            />
            {/* Render tags */}
            {/* {tags.map((tag) => (
                <span key={tag.id}>{tag.name}</span>
            ))} */}
        </div>
    );
});

export default Comp_ClientContactTypes;
